<template>
  <div>
    <ld-header @click-right="confrim">
      <span
        slot="right"
        class="main-color"
      >
        下一步
      </span>
      
      修改手机号码
    </ld-header>
    
    <van-cell-group>
      <van-field
        label="原手机号"
        v-model="empInfo.phoneNumber"
        input-align="left"
        readonly
      />
      
      <van-field
        v-model="password"
        label="当前密码"
        ref="password"
        type="password"
        placeholder="请输入当前密码"
        autofocus
        required
      />
    </van-cell-group>

    <van-popup 
      v-model="modifyShow"
      :close-on-popstate="true"
      position="right"
      :style="{ width: '100%', height: '100%' }"
    >
      <ld-header
        @click-right="submit"
        @click-left="modifyShow = false"
      >
        <span
          slot="right"
          class="main-color"
        >
          {{ $t('B010','保存') }}
        </span>
        
        新的手机号
      </ld-header>
      
      <van-cell-group>
        <van-field
          label="新手机号"
          v-model="phoneNumber"
          placeholder="请输入新手机号码"
          input-align="left"
          required
          clearable
        />

        <van-field
          label="验证码"
          v-model="smsCode"
          placeholder="请输入验证码"
          input-align="left"
          maxlength="6"
          required
          clearable
        >
          <van-button
            slot="button"
            size="small"
            type="info"
            @click="getSmsValidCode()"
          >
            {{ smsCodeTips }}
          </van-button>
        </van-field>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import { Popup, CellGroup, Field, Button } from 'vant'
import { mapState } from 'vuex'
import { validators } from 'Utils/valid'
import { localget } from 'Utils/storage.js'

export default {
  name: 'ModifyMobile',
  components: {
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button
  },
  data() {
    return {
      password: '',
      modifyShow: false,
      phoneNumber: '',
      smsCode: '',
      smsCodeTips: '获取验证码'
    }
  },
  computed: {
    ...mapState({
      empInfo: state => state.app.userInfo.empInfo
    })
  },
  methods: {
    confrim () {
      if (this.password != localget('AutoLogin').password) {
        this.$toast('当前密码不正确')
        return
      }
      
      this.modifyShow = true
    },
    async submit() {
      if (!this.smsCode) {
        this.$toast('请输入验证号码')
        return
      }
      
      try {
        await this.$api['user/phoneBinding']({
          phoneNumber: this.phoneNumber,
          smsCode: this.smsCode
        })
        var self=this
        this.$dialog.alert({ message: '修改成功' }).then(() => {
          this.$store.dispatch('loginOut').then(()=>{
            self.$router.push('/login')
          }).catch(()=>{
            self.$router.push('/login')
          })
        })

      } catch (error) {
        throw error
      }
    },
    // 获取短信验证码
    async getSmsValidCode() {
      if (!validators.mobile(this.phoneNumber).valid) {
        this.$toast(validators.mobile(this.phoneNumber).msg)
        return
      }
      
      if(this.smsCodeTips !== '获取验证码' && this.smsCodeTips !== '重新发送') return false
      
      this.time()
        
      try {
        await	this.$api['user/smsCodeGet']({
          compId: this.empInfo.corpId,
          phoneNumber: this.phoneNumber,
          type: '绑定手机',
          isUpdate: '1'
        })
        
      } catch (error) {
        throw error
      }
      
    },
    time() {
      // 倒计时 60s
      let threshold = 60,
        count = 0
      let time = setInterval(() => {
        let diff = threshold - count
        count++
        this.smsCodeTips = `${diff} S`
        if (diff === 0) {
          clearInterval(time)
          this.smsCodeTips = '重新发送'
        }
      }, 1000)
    }
  }
}
</script>